import axios from "axios";
import authHeader from "services/auth-header";
import drIds from "services/dr-ids";

class PrescriptionService {
  medicines(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `medicines`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        return response.data;
      });
  }

  requirePrescription(id, params) {
    return axios
      .put(
        process.env.REACT_APP_API_ENDPOINT +
          "chat_sessions/" +
          id +
          "/prescription_required",
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  submitPrescription(params) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + "prescriptions", params, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getPrescription(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `prescriptions/${id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getPrescriptions(params) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + `prescriptions?${drIds()}`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        return response.data;
      });
  }

  confirmPickupLocation(id, params) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `prescriptions/${id}/confirm_pickup_location?${drIds()}`,
        params,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  readyForDelivery(id) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `prescriptions/${id}/ready_for_delivery?${drIds()}`,
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  rejectForDelivery(id) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `prescriptions/${id}/reject_for_delivery?${drIds()}`,
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  readyForPickup(id) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `prescriptions/${id}/ready_for_pickup?${drIds()}`,
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  request_delivery_service(id) {
    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT +
          `prescriptions/${id}/request_delivery_service?${drIds()}`,
        {},
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  getPickupLocations(params) {
    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT + `prescriptions/clinics?${drIds()}`,
        { headers: authHeader(), params: params }
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new PrescriptionService();
